import { render } from "./SliderCreateComponent.vue?vue&type=template&id=54368943"
import script from "./SliderCreateComponent.vue?vue&type=script&lang=js"
export * from "./SliderCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Slider/SliderCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54368943"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54368943', __exports__)) {
    api.reload('54368943', __exports__)
  }
  
  module.hot.accept("./SliderCreateComponent.vue?vue&type=template&id=54368943", () => {
    api.rerender('54368943', render)
  })

}


export default __exports__